



































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class AssessmentGrid extends Vue {
  @Prop() private options!: any;
  @Prop() private selectedOption!: number;

  private gotoNext() {
    this.$emit("gotoNext");
  }

  private onSelectOption(option: number) {
    this.$emit("onSelectedOption", option);
  }

  get rowOptions() {
    return this.chunkArray(this.options.list, this.options.list.length / 2);
  }

  private chunkArray(arr: any[], chunkCount: number) {
    const chunks = [];
    while (arr.length) {
      const chunkSize = Math.ceil(arr.length / chunkCount--);
      const chunk = arr.slice(0, chunkSize);
      chunks.push(chunk);
      arr = arr.slice(chunkSize);
    }
    return chunks;
  }
}
